import * as React from 'react';

import { StyledFileIcon, CustomBackground } from './styles';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';

interface FileIconProps {
	type: Api.AssetItemFileTypes;
	fileFormat: Api.AssetItemFileFormats;
	isProposal: boolean;
	isActive: boolean;
}

interface SvgProps {
	name: string;
	fill: string;
	width?: number;
	customBackground?: string;
	isBackgroundOnActiveState?: boolean;
}

const getSvgProps = (type: Api.AssetItemFileTypes, fileFormat: Api.AssetItemFileFormats, isProposal: boolean): SvgProps => {
	if (isProposal) {
		return {
			name: 'iconset_uprez_proposal',
			fill: NewStyleColor.Green,
		};
	}

	const isFileIcon = [
		Api.AssetItemFileFormats.DOCUMENT,
		Api.AssetItemFileFormats.PDF,
		Api.AssetItemFileFormats.PRESENTATION
	].includes(fileFormat);

	const props: SvgProps = {
		name: 'iconset_uprez_file',
		fill: StyleColor.Grey300,
		width: 13,
		customBackground: 'iconset_uprez_file_background',
	};

	if (isFileIcon) {
		switch (fileFormat) {
			case Api.AssetItemFileFormats.DOCUMENT:
				props.name = 'iconset_uprez_file_doc';
				break;
			case Api.AssetItemFileFormats.PDF:
				props.name = 'iconset_uprez_file_pdf';
				break;
			case Api.AssetItemFileFormats.PRESENTATION:
				props.name = 'iconset_uprez_file_presentation';
				break;
			default:
				return props;
		}

		return props;
	} else {
		switch (type) {
			case Api.AssetItemFileTypes.PUBLICATION:
				return {
					name: 'iconset_page-bold',
					fill: NewStyleColor.Blue100,
				};
			case Api.AssetItemFileTypes.IMAGE:
				return {
					name: 'iconset_gallery-bold',
					fill: NewStyleColor.Pink,
				};
			case Api.AssetItemFileTypes.MOVIE:
				return {
					name: 'iconset_video-bold',
					fill: StyleColor.Grey300,
					isBackgroundOnActiveState: true,
				};
			case Api.AssetItemFileTypes.COMPONENT:
				return {
					name: 'iconset_template-bold',
					fill: StyleColor.Grey500,
				};
			default:
				return props;
		}
	}
};

const FileIcon = ({ type, fileFormat, isProposal, isActive }: FileIconProps) => {
	const {
		name,
		fill,
		width,
		customBackground,
		isBackgroundOnActiveState,
	} = getSvgProps(type, fileFormat, isProposal);

	return (
		<StyledFileIcon
			isActive={isActive}
			width={width}
			isCustomBackground={!!customBackground}
			isBackgroundOnActiveState={isBackgroundOnActiveState}
		>
			{Utils.getSvgIcon(name, { fill })}
			{isActive && !!customBackground &&
				<CustomBackground width={width}>
					{Utils.getSvgIcon(customBackground)}
				</CustomBackground>
			}
		</StyledFileIcon>
	);
};

export default FileIcon;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/FileIcon/index.tsx